import {Directive, Module} from 'app/decorators';

@Module({
    name: "app.directives.formvalidate",
})
@Directive('form-error', function($uibTooltip, $timeout, $compile){
    "ngInject";
    /*
    3 ways of specifying where seek for errors:
    1. corresponding ng-model attr
    2. corresponding ng-model attr + prefix
    3. form-errors="vm.errors.field"
     */
    return {
        link: function(scope, element, attrs) {
            let $el = element[0];
            let prefix = attrs.prefix || 'errors';
            let name = attrs.formError;
            if (!name) {
                name = attrs.ngModel;
                if (name) {
                    name = name.split('.');
                    name[1] = prefix;
                    name = name.join('.');
                }
            }
            if (!name) {
                return;
            }
            $el.removeAttribute('form-error');
            $el.setAttribute('uib-popover', `{{ ${name}[0] }}`);
            $el.setAttribute('popover-trigger', "'mouseenter'");

            let watcher = scope.$watch(name, function (value) {
                let $parent = element[0].parentElement;
                if (!value || value.length < 0) {
                    $parent.classList.remove('has-error');
                } else {
                    $parent.classList.add('has-error');
                }
            });

            $compile(element)(scope);

            scope.$on('$destroy', function () {
                watcher();
                watcher = null;
                element.remove();
            });

        }
    };
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/form.validation.js